import * as SegmentGroup from '@/components/ui/segment-group'
import { useLocation, useNavigate } from '@solidjs/router'
import { Box } from 'styled-system/jsx'

export default function () {
  const location = useLocation()
  const navigate = useNavigate()

  const activeTab = () => {
    const pathname = location.pathname
    const lastPathFragment = pathname.substring(pathname.lastIndexOf('/') + 1)
    return lastPathFragment.length > 0 ? lastPathFragment : 'admin'
  }

  return (
    <Box display="grid" gridTemplateColumns="auto 1fr">
      <SegmentGroup.Root
        value={activeTab()}
        onValueChange={(details) => {
          const path = details.value === 'admin' ? '/admin' : `/admin/${details.value}`
          navigate(path)
        }}
        size="xs"
        orientation="horizontal"
        colorPalette="tscGreen"
      >
        <SegmentGroup.Indicator />

        <SegmentGroup.Item value="admin">
          <SegmentGroup.ItemText textStyle="xs">Users</SegmentGroup.ItemText>
          <SegmentGroup.ItemControl position="absolute" />
          <SegmentGroup.ItemHiddenInput />
        </SegmentGroup.Item>

        <SegmentGroup.Item value="add-new">
          <SegmentGroup.ItemText textStyle="xs">Add New</SegmentGroup.ItemText>
          <SegmentGroup.ItemControl position="absolute" />
          <SegmentGroup.ItemHiddenInput />
        </SegmentGroup.Item>
        <SegmentGroup.Item value="events">
          <SegmentGroup.ItemText textStyle="xs">Events</SegmentGroup.ItemText>
          <SegmentGroup.ItemControl position="absolute" />
          <SegmentGroup.ItemHiddenInput />
        </SegmentGroup.Item>
      </SegmentGroup.Root>
      <div />
    </Box>
  )
}
